import { Component, OnInit, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { environment } from 'environments/environment';

@Component({
    selector: 'app-landing-page',
    templateUrl: './landing-page.component.html',
    styleUrls: ['./landing-page.component.css']
})
export class LandingPageComponent implements OnInit {
    sideBar: boolean = false;
    play: boolean = false;
    stickHeader = false;
    showStickyNavbar = false;
    showGoTop = false;

    constructor(private router: Router) {
    }


    ngOnInit(): void {
    }

    @HostListener('document:scroll', ['$event'])
    onDocumentScroll(event: Event) {
        const scroll = document.documentElement.scrollTop || document.body.scrollTop || 0;
        this.stickHeader = scroll >= 42;
        this.showStickyNavbar = scroll > 200;
        this.showGoTop = scroll >= 300;
    }


    @HostListener('window:resize')
    @HostListener('window:scroll')
    checkAnimations() {
        const elements = document.querySelectorAll<HTMLElement>('.add-animate');
        const docViewTop = window.scrollY || document.documentElement.scrollTop;
        const docViewBottom = docViewTop + window.innerHeight;

        elements.forEach(el => {
            const elementTop = el.offsetTop;
            const elementBottom = elementTop + el.offsetHeight;
            if (elementBottom > docViewTop && elementTop < docViewBottom) {
                const animateType = el.getAttribute('data-animated');
                if (animateType) {
                    el.classList.add('animated', animateType.trim());
                    el.classList.remove('add-animate');
                }
            }
        });
    }

    openContactUs() {
        this.router.navigateByUrl('/contact-us');
    }

    /** Function for login */
    doLogin() {
        window.location.href = environment['loginUrl'] + '&redirect_uri=' + encodeURIComponent(environment['redirectUrl']);
    }

    /** Go to top button press */
    goToTop() {
        window.scrollTo({top: 0, behavior: 'smooth'});
        this.showGoTop = false;
    }

    /** function for play video */
    playVideo() {
        this.play = !this.play;
    }
}